import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getPairs = () => client.get("/pairs").then((r) => r.data);
export const getStats = () => client.get("/stats").then((r) => r.data);
export const getCoins = (params = {}) =>
  client.get("/coins", { params }).then((r) => r.data);
export const getCoin = (id) => client.get(`/coins/${id}`).then((r) => r.data);
export const createCoin = (payload) =>
  client.post("/coins", payload).then((r) => r.data);
export const getChart = (id, range) =>
  client.get(`/coins/${id}/chart`, { params: { range } }).then((r) => r.data);
export const getTrades = (id) =>
  client.get(`/coins/${id}/trades`).then((r) => r.data);
export const createTrade = (id, payload) =>
  client.post(`/coins/${id}/trades`, payload).then((r) => r.data);

export const getConfig = () => client.get("/config").then((r) => r.data);
export const getOnchainTrades = (address) =>
  client.get(`/onchain/trades/${address}`).then((r) => r.data);
export const getOnchainFees = (token) =>
  client.get(`/onchain/fees/${token}`).then((r) => r.data);

export const uploadImage = (fileFormData) =>
  client.post("/upload", fileFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);

export const startDeploy = (payload) =>
  client.post("/deploy", payload).then((r) => r.data);
export const getDeployStatus = (jobId) =>
  client.get(`/deploy/${jobId}`).then((r) => r.data);

export default client;
